const icon = {};
const icon2 = {};
const common = {};
const req = require.context("./ico", false, /\.(png|jpe?g|svg)$/);
const reqIcon2 = require.context("./ico2", false, /\.(png|jpe?g|svg)$/);
const reqCommon = require.context("./common", false, /\.(png|jpe?g|svg)$/);

req.keys().forEach((key) => {
  const name = key.replace("./", "").replace(/\.(png|jpe?g|svg)$/, "");
  icon[name] = req(key);
});

reqIcon2.keys().forEach((key) => {
  const name = key.replace("./", "").replace(/\.(png|jpe?g|svg)$/, "");
  icon2[name] = reqIcon2(key);
});

reqCommon.keys().forEach((key) => {
  const name = key.replace("./", "").replace(/\.(png|jpe?g|svg)$/, "");
  common[name] = reqCommon(key);
});

const images = {
  icon,
  icon2,
  ...common,
};

export { images };
